"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomSharedEntity = exports.isAdaptableSharedEntity = void 0;
const isAdaptableSharedEntity = (entity) => entity.EntityType === 'adaptableEntity';
exports.isAdaptableSharedEntity = isAdaptableSharedEntity;
const isCustomSharedEntity = (entity) => entity.EntityType === 'customEntity';
exports.isCustomSharedEntity = isCustomSharedEntity;
